import {
  Css_Text_16_24,
  SimpleMuiButton,
  Text_16_24,
  Text_20_30,
  Text_24_36,
} from '@dreamstack/feature-components'
import { useTranslation } from '@dreamstack/i18n'
import { ArrowRight } from '@dreamstack/icons'
import type { FunctionComponent } from 'react'
import tw, { styled } from 'twin.macro'

export const StockBox = tw.div`
  text-accentroWhite-full  
  bg-accentroGray-full 
  flex 
  flex-col 
  justify-between 
  w-full
  p-px-24
  space-y-px-32
  lg:(p-px-32)
  `
const LeftTd = tw.td`pr-px-16`
const RightTd = tw.td`font-semibold`
const StockText = tw.p`mb-px-8 text-px-13 leading-px-18 lg:(text-px-16 leading-px-24)`

const TableWrapper = styled.div(Css_Text_16_24)

//TODO: Get stock price from an api.
export const StockPriceSectionCustom: FunctionComponent<React.PropsWithChildren<{}>> = () => {
  const t = useTranslation()
  return (
    <StockBox>
      <div tw="flex justify-between">
        <Text_16_24>{t('accentro:stock.latestStockQuote')}</Text_16_24>
        <SimpleMuiButton variant="contained" color="primary">
          <ArrowRight width={30} height={30} />
        </SimpleMuiButton>
      </div>
      <div>
        <Text_24_36 tw="font-semibold">7,90 EUR</Text_24_36>
        <Text_20_30 tw="block">+1,28 %</Text_20_30>
      </div>
      <TableWrapper>
        <StockText>Accentro Real Estate AG (XETRA)</StockText>
        <table>
          <tbody>
            <tr>
              <LeftTd>WKN</LeftTd>
              <RightTd>A0KFKB</RightTd>
            </tr>
            <tr>
              <LeftTd>ISIN</LeftTd>
              <RightTd>DE000A0KFKB3</RightTd>
            </tr>
          </tbody>
        </table>
      </TableWrapper>
    </StockBox>
  )
}
